<template>
  <div class="nav-box" :class="{ desktop: isDesktop }">
    <div class="code-box">
      <div class="nav-title">
        <div class="nav-left">
          <svg class="icon-home icon-svg" @click="returnHome">
            <use xlink:href="#icon-home" />
          </svg>
          <span class="ellipsis"> / {{ currentClass?.ClassName }}</span>
        </div>

        <div class="nav-right">
          <a-tooltip @click="swichNavMax()" v-if="showNav">
            <template #title>{{ navMax ? '解除固定' : '固定菜单' }}</template>
            <svg class="icon-svg icon-fold" :class="{ fixed: navMax }">
              <use xlink:href="#icon-fixed" />
            </svg>
          </a-tooltip>
          <a-tooltip @click="foldNav()">
            <template #title>关闭菜单</template>
            <svg class="icon-svg popup-close">
              <use xlink:href="#icon-close" />
            </svg>
          </a-tooltip>
        </div>
      </div>
      <div class="int-list">
        <div class="int-item" v-for="(int, i) in intList">
          <div class="int-title">
            <svg class="icon-svg icon-xiala" :class="{ isFold: int.isFold }" @click="int.isFold = !int.isFold">
              <use xlink:href="#icon-xiala" />
            </svg>
            <span class="ellipsis" @click="switchChapter(i)">{{ int.InductionName }}</span>
          </div>
          <div class="cint-list" :class="{ 'fadeIn': !int.isFold, 'foldIn': int.isFold }">
            <div class="cint-item" v-for="cint in int.children">
              <div class="citem-title" :class="{ hide: int.children.length == 1 }">
                <span>{{ cint.InductionName }}</span>
              </div>
              <div class="code-item" @click="openCode(item)" v-for="(item, i) in cint.data">
                <i class="i-dot"></i>
                <svg class="icon-svg code-icon">
                  <use :xlink:href="item.icon" />
                </svg>
                <div class="code-title">{{ item.Title }} - {{ item.ProjectName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    LoadingOutlined
  } from '@ant-design/icons-vue';

  export default {
    name: 'pilot-nav',
    components: {
      LoadingOutlined
    },
    props: {},
    data() {
      return {
        intList: [],
        navMax: false,
        showNav: true,
        userInfo: null,

        currentClass: null,
        isSharer: false,

        isDesktop: false,
      }
    },
    mounted() {
      let {
        intList,
        userInfo,
        isSharer,
        currentClass
      } = this.$store.state;
      this.intList = intList;
      this.userInfo = userInfo;
      this.isSharer = isSharer;
      this.currentClass = currentClass;

      this.isDesktop = !!(window && window.process && window.process.type);

      const debounce = this.debounce(this.setHeight, 100);
      window.addEventListener('resize', debounce);
    },
    methods: {
      //设置各互动高度
      setHeight() {
        const wWidth = window.innerWidth;
        if (wWidth < 1000) {
          this.showNav = false;
          if (this.navMax) this.swichNavMax();
        } else this.showNav = true;
      },
      //选择code
      openCode(code) {
        this.$emit('openCode', code);
      },
      //选择章节
      switchChapter(i) {
        this.$emit('switchChapter', i);
      },
      //折叠
      swichNavMax() {
        this.navMax = !this.navMax;
        this.$emit('swichNavMax', this.navMax);
      },
      //关闭
      foldNav() {
        this.navMax = false;
        this.$emit('swichNavMax', this.navMax);
        this.$emit('foldNav', true)
      },
      //跳转首页
      returnHome() {
        window.location.href = 'https://yuanxi.online';
      },

      //防抖
      debounce(fn, delay) {
        let timer;
        return function () {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            fn();
          }, delay);
        }
      },
    },
    //组件销毁
    beforeUnmount() {
      const debounce = this.debounce(this.setHeight, 100);
      window.removeEventListener('resize', debounce);
    }
  }
</script>

<style scoped lang="scss">
  @import "./pilot-nav.scss";
</style>